export const CLEAR_SESSION = 'auth/CLEAR_SESSION'
export const SET_SESSION = 'auth/SET_SESSION'
export const SET_NEXT_ROUTE = 'auth/SET_NEXT_ROUTE'
export const RESET_NEXT_ROUTE = 'auth/RESET_NEXT_ROUTE'
